import React, {useState, useEffect} from 'react';
import ResultListingBody from './resultListingBody';
import Moment from 'react-moment';
// import ICONS from "assets/images/index.js";
import ResultTrends from './resultTrends';
// import { Icon } from 'helpers/icons';
import { FaPrint } from "react-icons/fa";
import { usePrintLabOrderFileMutation, usePrintResultsMutation, usePrintTrendsMutation } from '../../../services/labService';
// import { dataURItoFile } from 'helpers/common.lib';
import { shallowEqual, useSelector } from 'react-redux';
// import { useGetPatientQuery } from 'app/redux/patientService';
import { Icon } from '../../../helpers/icons';
import { dataURItoFile } from '../../../helper';
import { useGetPatientQuery } from '../../../services/patientService';

const ResultListing = ({test, fromModule}) => {
    const [resultCollapse, setResultCollapse] = useState({});
    const [printInProgress, setPrintInProgress] = useState(null);

    const { auth, selectedNote } = useSelector(
        ({ auth, providerNote }) => ({
          auth,
          selectedNote: providerNote.selectedNote,
        }),
        shallowEqual
    );


    const { data: selectedPatient } = useGetPatientQuery(selectedNote?.pid);

    const togglResult = (lab_id) => {
        const val = resultCollapse[lab_id] ? false : true;
        setResultCollapse({...resultCollapse, [lab_id]: val});
    }

    const [printTrends] = usePrintTrendsMutation();
    const [
        printResults,
    ] = usePrintResultsMutation();
    const printLabTestTrends = async() =>{
        
        let formData = new FormData();
        let tempPostData = [];

        const tempTest = test.observations?.map((result, index)=>{
            var graphDiv = document.getElementById(`vis_${test.id}_${result.ltscode}_${index}`);
            var wrapperDiv = graphDiv.getElementsByTagName('div')[0];
            var canvas = wrapperDiv.getElementsByTagName('canvas')[0];

            // Create in meomery canvas with different size
            var smallCanvas = document.createElement("canvas");
            var smallContext = smallCanvas.getContext("2d")
            smallCanvas.width = 650;
            smallCanvas.height = 450;
            smallContext.clearRect(0, 0, smallCanvas.width, smallCanvas.height);
            smallContext.drawImage(canvas, 0, 0, smallCanvas.width, smallCanvas.height);

            var file = dataURItoFile(smallCanvas.toDataURL(), test.id+' '+result.short_desc);
            
            formData.append(`file[${result.id}]`, file);
            return {...result}
        })

        tempPostData.push(tempTest);

        formData.append('patient', JSON.stringify({dos: selectedNote.encounter_data.date, name: selectedPatient.Patient?.full_name, age: selectedPatient.Patient?.age, dob: selectedPatient.Patient?.DOB, mrn: selectedPatient?.Patient?.mrn}));
        formData.append("file_data", JSON.stringify(tempPostData));
        setPrintInProgress(test.id);
        const res = await printTrends(formData);
        setPrintInProgress(null)
        
        if(res?.data?.code == 0){
            window.open( process.env.REACT_APP_API_URL_V1 + '/utilities/get_attachment.json?attachment='+ res.data?.data?.uuid +'&token=' + auth.authToken +"&tz="+ new Date().getTimezoneOffset() + '&practice_id=' + auth.practice_id, "_blank");
        }
    }

    const printLabTestResults = async() =>{
        let observationIds = []
        const tempTest = test.TestResults?.map((result, index)=>{
            observationIds.push(result.observation_id);
        })
        setPrintInProgress(test.id);
        const res =  await printResults({lab_order_id: observationIds?.join(',')});
        setPrintInProgress(null)
        
        if(res?.data?.code == 0){
            window.open( process.env.REACT_APP_API_URL_V1 + '/utilities/get_attachment.json?attachment='+ res.data?.data?.uuid +'&token=' + auth.authToken +"&tz="+ new Date().getTimezoneOffset() + '&practice_id=' + auth.practice_id, "_blank");
        }
    }

    return(
        <div key={test.id} className="items-center">
            <div className="flex justify-between items-center text-white bg-teal1000 hover:bg-primary-hover border-teal-c-800 border-l-4 mt-0.5 py-1.5 px-2.5">
                <div className="flex flex-row items-center gap-x-2 cursor-pointer" onClick={() => togglResult(test.id)}>
                    <Icon type="test_icon" />
                    <button>
                        {/* <img src={resultCollapse[test.id] ? ICONS.arrowForward : ICONS.arrowDown } className="icon-w-14 icon-h-14"
                        alt="" /> */}
                    </button>
                    <p className="font-normal text-base">
                        {`${test.code ? test.code+' - ' : ''}  ${test.short_desc}`}
                    </p>
                </div>
                <div className='cursor-pointer'>
                    {printInProgress == test.id ?
                        <Icon type="inline-loader" />
                        :
                        fromModule == 'lab_trends' ? <FaPrint onClick={ printLabTestTrends } title="Print" /> : null
                    }
                </div>
            </div>
            {/* {!resultCollapse[test.id] ? */}
                <div className={`box-shadow ${!resultCollapse[test.id] ? '' : 'hidden'}`}>
                    {fromModule == 'lab_trends' ?
                        <ResultTrends test={test} />
                        :
                        <ResultListingBody test={test} />
                    }
                </div>
            {/*     : null
             } */}
        
        </div>
    )
}

export default ResultListing;